import React from "react";
import { Box } from "@mui/material";
import LazyImage from "../LazyLoadingImage/LazyImage";
import { collectItemImages } from "./itemImages";

interface ListItemImagesProps {
  item: { picture?: string | null; images?: string[]; name: string };
}

/**
 * Every image, stacked.
 *
 * The product detail page moved to `ImageCarousel` in EB-537; this stays for the education detail
 * page, which renders it twice and wants the whole set visible at once. The two share
 * `collectItemImages` so they cannot disagree about which images a record has.
 */
const ListItemImages: React.FC<ListItemImagesProps> = ({ item }) => {
  const unique = collectItemImages(item);

  if (unique.length === 0) return null;

  return (
    <Box>
      {unique.map(({ url }, i) => (
        <LazyImage
          key={`${url}-${i}`}
          src={url}
          alt={`${item.name} ${i + 1}`}
          style={{ width: "100%", objectFit: "cover" }}
        />
      ))}
    </Box>
  );
};

export default ListItemImages;
